module.exports = __webpack_public_path__ + "static/img/partner_XX.14b6d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XX.png
// module id = xuD7
// module chunks = 9